export interface ISlackWorkflowAPI {
    webHookUrl: string;
}

export class SlackWorkflowAPI {

    private readonly webHookUrl: string;

    constructor({ webHookUrl }: ISlackWorkflowAPI) {
        this.webHookUrl = webHookUrl;
    }

    sendMessageToWebhook(body: {}) {
        return fetch(this.webHookUrl, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
}
